import { Injectable } from '@angular/core';
import { createFeatureSelector, createSelector, on, props } from '@ngrx/store';
import { SafariObjectId } from '@safarilaw-webapp/shared/common-objects-models';
import { SafariReduxUiObject } from '@safarilaw-webapp/shared/redux';
import { ConfirmationDialogRequest, ConfirmationDialogResponse } from '../../dialog/models/confirmation-dialog-payload';
import { IDialogState } from '../interfaces/dialog-interface';
import { ISharedState } from '../state.interface';

const getSharedFeatureState = createFeatureSelector<ISharedState>('dialogs');

const getDialogState = createSelector(getSharedFeatureState, state => state.dialogState);

@Injectable({ providedIn: 'root' })
export class AppDialogUiReduxObject extends SafariReduxUiObject<IDialogState, any> {
  // TODO: Follow example in matterpage redux object to combine into action/selector and get rid of default
  default = {
    actions: {
      modalDialogDismissed: super.createAction('Modal Dialog Dismissed', props<{ payload: ConfirmationDialogResponse }>()),
      openModalDialog: super.createAction('Open Modal Dialog', props<{ payload: ConfirmationDialogRequest }>()),
      closeModalDialog: super.createAction('Close Modal Dialog', props<{ payload: { id: SafariObjectId[] | SafariObjectId } }>()),
      clearDialogResponse: super.createAction('Clear Dialog Response')
    },
    selectors: {
      getDialogResponse: createSelector(getDialogState, state => state.dialogResponse),
      getDialogRequest: createSelector(getDialogState, state => state.dialogRequest),
      getCloseDialogRequest: createSelector(getDialogState, state => state.closeDialogRequest)
    },
    reducers: ons => {
      ons.push(
        on(this.default.actions.modalDialogDismissed, (state: IDialogState, action: { payload: ConfirmationDialogResponse }) => ({ ...state, dialogResponse: action.payload })),
        on(this.default.actions.clearDialogResponse, (state: IDialogState) => ({ ...state, dialogResponse: null })),
        on(this.default.actions.closeModalDialog, (state: IDialogState, action: { payload: { id: SafariObjectId[] | SafariObjectId } }) => {
          const ids = Array.isArray(action.payload.id) ? action.payload.id : [action.payload.id];

          return { ...state, closeDialogRequest: { ids } };
        }),
        on(this.default.actions.openModalDialog, (state: IDialogState, action: { payload: ConfirmationDialogRequest }) => ({ ...state, dialogRequest: action.payload }))
      );
    }
  };
  constructor() {
    super('App', 'Dialog');
    super
      .addState({
        dialogResponse: null,
        dialogRequest: null,
        closeDialogRequest: null
      })
      .finalize();
  }
}
